<template>
  <section>
    <v-card
      v-for="(r, i) in item"
      :key="i"
    >
      <v-card-text>
        <div class="card-head">
          <div>{{ r?.title }}</div>
          <div
            v-if="r?.status"
            class="card-status card-red"
          >
            {{ r?.status }}
          </div>
        </div>
        <div class="card-values">
          <span class="card-value">{{ r?.value }}</span>
          <span class="card-unit">
            {{ r?.unit }}
          </span>
        </div>
        <div class="card-text">
          {{ r?.text }}
        </div>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
export default {
  props: {
    item: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="sass" scoped>

// section
//     display: flex
//     flex-wrap: wrap
//     gap: 1rem
//     >div
//         flex-basis: 24%

section
  display: grid
  grid-template-columns: repeat(4, 1fr)
  gap: 1rem

@media (max-width: 1024px)
  section
    grid-template-columns: repeat(2, 1fr)

@media (max-width: 600px)
  section
    grid-template-columns: 1fr

.card-head
    display: flex
    justify-content: space-between
    align-items: center
    .card-title
        color: gray
    .card-status
        text-transform: capitalize
        padding: 2px 10px
        border-radius: 15px

    .card-red
        background: #efbbbb
        color: #e85353

    .card-yellow
        background: #fcf3b8
        color: #8e9e14

.card-values
    padding-top: 1rem
    .card-value
        font-size: 2rem
        font-weight: bold



@media (max-width: 480px)
  section
    >div
        flex-basis: 100%
</style>
